export enum eUserRole {
  ADMIN = 'ADMIN',
  SELLER = 'SELLER',
  OWNER = 'OWNER',
  VIEWER = 'VIEWER',
}

export enum eUserStateType {
  LINKED = 'linked',
  UNLINKING = 'unlinking',
  UNLINKED = 'unlinked',
  PENDING = 'pending',
  INVITATION_SENT = 'invitation_sent',
  INVITATION_EXPIRED = 'invitation_expired',
  INTEGRATION_CONNECTION_PENDING = 'integration_connection_pending',
}
